import TkCheckbox from "../../../components/atoms/TkCheckbox";

function getHeadList(year: number) {
  const tableHeadList: any = [
    {
      top: {
        headTitle: year + "年度　ならない月",
      },
      bottom: [
        {
          headTitle: "無",
        },
        {
          headTitle: "4月",
        },
        {
          headTitle: "5月",
        },
        {
          headTitle: "6月",
        },
        {
          headTitle: "7月",
        },
        {
          headTitle: "8月",
        },
        {
          headTitle: "9月",
        },
        {
          headTitle: "10月",
        },
        {
          headTitle: "11月",
        },
        {
          headTitle: "12月",
        },
        {
          headTitle: "1月",
        },
        {
          headTitle: "2月",
        },
        {
          headTitle: "3月",
        },
      ],
    },
  ];

  return tableHeadList;
}

function getBodyList(data: any) {
  const bodyList: any[] = [
    {
      children: (
        <TkCheckbox
          checked={data?.non === "1" || data?.non === "3"}
          disabled={true}
        />
      ),
      align: "center",
    },
    {
      children: (
        <TkCheckbox
          checked={data?.apr === "1" || data?.apr === "3"}
          disabled={true}
        />
      ),
      align: "center",
    },
    {
      children: (
        <TkCheckbox
          checked={data?.may === "1" || data?.may === "3"}
          disabled={true}
        />
      ),
      align: "center",
    },
    {
      children: (
        <TkCheckbox
          checked={data?.jun === "1" || data?.jun === "3"}
          disabled={true}
        />
      ),
      align: "center",
    },
    {
      children: (
        <TkCheckbox
          checked={data?.jul === "1" || data?.jul === "3"}
          disabled={true}
        />
      ),
      align: "center",
    },
    {
      children: (
        <TkCheckbox
          checked={data?.aug === "1" || data?.aug === "3"}
          disabled={true}
        />
      ),
      align: "center",
    },
    {
      children: (
        <TkCheckbox
          checked={data?.sep === "1" || data?.sep === "3"}
          disabled={true}
        />
      ),
      align: "center",
    },
    {
      children: (
        <TkCheckbox
          checked={data?.oct === "1" || data?.oct === "3"}
          disabled={true}
        />
      ),
      align: "center",
    },
    {
      children: (
        <TkCheckbox
          checked={data?.nov === "1" || data?.nov === "3"}
          disabled={true}
        />
      ),
      align: "center",
    },
    {
      children: (
        <TkCheckbox
          checked={data?.dec === "1" || data?.dec === "3"}
          disabled={true}
        />
      ),
      align: "center",
    },
    {
      children: (
        <TkCheckbox
          checked={data?.jan === "1" || data?.jan === "3"}
          disabled={true}
        />
      ),
      align: "center",
    },
    {
      children: (
        <TkCheckbox
          checked={data?.feb === "1" || data?.feb === "3"}
          disabled={true}
        />
      ),
      align: "center",
    },
    {
      children: (
        <TkCheckbox
          checked={data?.mar === "1" || data?.mar === "3"}
          disabled={true}
        />
      ),
      align: "center",
    },
  ];

  return bodyList;
}

export { getHeadList, getBodyList };
